module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1012-fa74e95f6b58f7081478733d020c37bd.png";